// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { circularProgressClasses } from '@mui/material/CircularProgress';
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { rem } from '../../tokens/conversions';
import { progressBarColors } from './progressBarColors';
export var ProgressBar = function(mode) {
    var c = progressBarColors(mode);
    var override = {
        MuiLinearProgress: {
            styleOverrides: {
                // `inherit` keeps MUI's currentColor track and bar so the indicator follows its parent.
                root: function(param) {
                    var ownerState = param.ownerState;
                    return _object_spread({
                        height: rem(4),
                        borderRadius: rem(1)
                    }, ownerState.color !== 'inherit' && {
                        backgroundColor: c.default.background
                    });
                },
                bar: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.color === 'inherit' ? {} : {
                        backgroundColor: c.default.fill
                    };
                }
            },
            variants: [
                {
                    props: {
                        color: 'error'
                    },
                    style: _define_property({
                        backgroundColor: c.error.background
                    }, "& .".concat(linearProgressClasses.bar), {
                        backgroundColor: c.error.fill
                    })
                },
                {
                    props: {
                        color: 'success'
                    },
                    style: _define_property({}, "& .".concat(linearProgressClasses.bar), {
                        backgroundColor: c.success.fill
                    })
                },
                {
                    props: {
                        color: 'gray'
                    },
                    style: _define_property({
                        backgroundColor: c.gray.background
                    }, "& .".concat(linearProgressClasses.bar), {
                        backgroundColor: c.gray.fill
                    })
                },
                {
                    props: {
                        hasBackgroundFill: false
                    },
                    style: {
                        backgroundColor: 'transparent'
                    }
                }
            ]
        },
        MuiCircularProgress: {
            defaultProps: {
                size: 20
            },
            styleOverrides: {
                // MUI renders no track circle, so Figma's 2px track ring is drawn as an inset shadow on the root.
                root: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.color === 'inherit' ? {} : {
                        borderRadius: '50%',
                        boxShadow: "inset 0 0 0 ".concat(rem(2), " ").concat(c.default.background)
                    };
                },
                circle: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.color === 'inherit' ? {} : {
                        stroke: c.default.fill
                    };
                }
            },
            variants: [
                {
                    props: {
                        color: 'error'
                    },
                    style: _define_property({
                        boxShadow: "inset 0 0 0 ".concat(rem(2), " ").concat(c.error.background)
                    }, "& .".concat(circularProgressClasses.circle), {
                        stroke: c.error.fill
                    })
                },
                {
                    props: {
                        color: 'gray'
                    },
                    style: _define_property({
                        boxShadow: "inset 0 0 0 ".concat(rem(2), " ").concat(c.gray.background)
                    }, "& .".concat(circularProgressClasses.circle), {
                        stroke: c.gray.fill
                    })
                },
                {
                    props: {
                        hasBackgroundFill: false
                    },
                    style: {
                        boxShadow: 'none'
                    }
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=ProgressBar.js.map